import { useState } from 'react';
import type { HoaDonMuaHangTrongNuoc } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useHoaDonMuaHangTrongNuocExport = (
  rows: HoaDonMuaHangTrongNuoc[] = [],
  queryParams: Record<string, MuaHangRecord> = {}
) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportHoaDonMuaHangTrongNuocExcel, exportHoaDonMuaHangTrongNuocFromApi } =
        await import('../utils/excel-export');
      if (entity?.slug) {
        await exportHoaDonMuaHangTrongNuocFromApi({
          entitySlug: entity.slug,
          queryParams
        });
        return;
      }

      if (!rows.length) {
        toast({
          description: 'Không có dữ liệu để kết xuất.',
          variant: 'default'
        });
        return;
      }

      await exportHoaDonMuaHangTrongNuocExcel(rows);
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug) || rows.length > 0,
    isExporting
  };
};
